<template>
  <form
    class="order-search flex flex-row items-center gap-2"
    @submit.prevent="submit"
  >
    <input
      type="search"
      v-model="search"
      placeholder="Search by order number"
      class="border border-gray-300 rounded-md px-3 py-2"
    />
    <button
      type="submit"
      class="default-button px-4 py-2"
      :class="{ 'font-bold': search !== value }"
    >
      Search
    </button>
  </form>
</template>
<script>
// Busca por numero de orden u order key (prefijo). Solo emite al confirmar con
// Enter o con el boton: emitir por tecla consultaba la base en cada caracter.
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      search: this.value
    };
  },
  watch: {
    value(val) {
      this.search = val;
    }
  },
  methods: {
    submit() {
      const search = this.search.trim();
      if (search === this.value) return;
      this.$emit("search", search);
    }
  }
};
</script>
<style lang="postcss" scoped>
.order-search {
  width: 100%;
  max-width: 480px;

  input {
    flex: 1;
    min-width: 0;
    font-size: 14px;
  }
}
</style>
